module.exports = __webpack_public_path__ + "img/audio.ce9b5b46.svg";